import { z } from "zod";
import {
  DateTypeSchema,
  SourceTypeSchema,
  StatusTypeSchema,
} from "./core.schema";
import { TagSchema } from "./tag.schema";

// Schemas

export const BaseFirestoreSchema = z.object({
  _deleted: z.boolean(),
  _version: z.number(),
  _preserveVersion: z.boolean().optional(),
  _schemaVersion: z.number(),
  _source: SourceTypeSchema,
  id: z.string(),
  createdAt: DateTypeSchema,
  updatedAt: DateTypeSchema,
  createdBy: z.string(),
  updatedBy: z.string(),
});

export const BaseFirestoreWStatusSchema = BaseFirestoreSchema.extend({
  status: StatusTypeSchema,
});

export const BaseFirestoreWStatusTagsSchema = BaseFirestoreSchema.extend({
  status: StatusTypeSchema,
  tags: TagSchema.array().optional(),
});
